<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }">{{ label }}</label>
<div class="control-wrapper">
  <div>
    <div>
      <p-inputNumber
        class="mr-05"
        [(ngModel)]="selectedValue"
        (keydown)="detectDecimalSeparator($event)"
        mode="decimal"
        locale="de-DE"
        [minFractionDigits]="minFract"
        [maxFractionDigits]="maxFract"
        [disabled]="control.disabled || forceDisable"></p-inputNumber>
      <ng-content select="app-suffix"></ng-content>
    </div>
    <app-errors [errors]="errors" [showErrors]="!control.pristine && !control.disabled"></app-errors>
  </div>
</div>
